import React, { PureComponent } from 'react'
import * as R from 'ramda'

import { getOptionTitle, getOptionMetric } from '../../../../../utils/QuestionHelper'

class OptionTitle extends PureComponent {
    render() {
        const {
            id,
            option,
            locale,
            defaultLocale,
            initialLocale,
            toggleOther,
            reportStore,
            data,
        } = this.props

        const title = option
            ? getOptionTitle({
                langs: option.langs,
                locale,
                defaultLocale,
                initialLocale,
            })
            : 'not found'

        const dataOption = data
            ? data.yOptions.find((o) => o.id === id)
            : null
        const metricId = R.pathOr(null, ['metricId'], dataOption)
        const metric = metricId ? getOptionMetric({
            availableMetrics: reportStore.metrics,
            metricId,
            locale,
            defaultLocale,
            initialLocale: 'en_GB',
        }) : null

        return (
            <div>
                {
                    option && option.hasOptionOther
                        ? (
                            <a onClick={toggleOther} id={id}>
                                {title}
                                {metric ? `(${metric})` : null}
                            </a>
                        )
                        : `${title} ${metric ? `(${metric})` : ''}`
                }
            </div>
        )
    }
}

export default OptionTitle
